import { makeUseAxios } from 'axios-hooks';
import { LRUCache } from 'lru-cache';
import axios from 'axios';
import { env } from 'Shared/constants/env';
import { makeApiHooks } from './makeHooks';

const cache = new LRUCache<any, any>({ max: 10 });

const cancelInterceptor = (error: any) => {
  if (axios.isCancel(error)) {
    return new Promise(() => {});
  }
  return Promise.reject(error);
};

const axiosInstance = axios.create({
  baseURL: `${env.incentiveProgramsHostname}/incentive_programs`,
  headers: { Source: `core-app/${env.versionNumber}` },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  cancelInterceptor
);

const useAxios = makeUseAxios({
  axios: axiosInstance,
  cache: cache as any,
});

export const {
  useLazyApi: useLazyIncentiveProgramsApi,
  useApi: useIncentiveProgramsApi,
  useNewApi: useNewIncentiveProgramsApi,
} = makeApiHooks(useAxios);
